import {
  HiOutlineHome,
  HiOutlineUser,
  HiOutlineBadgeCheck,
  HiOutlineClipboardList,
  HiOutlinePhotograph,
  HiOutlineMail,
} from 'react-icons/hi'

export const data = [
  { label: 'Home', path: '/', id: 'home', icon: HiOutlineHome },
  { label: 'About', path: '/about', id: 'about', icon: HiOutlineUser },
  { label: 'Skills', path: '/skills', id: 'skills', icon: HiOutlineBadgeCheck },
  {
    label: 'Projects',
    path: '/projects',
    id: 'portfolio',
    icon: HiOutlinePhotograph,
  },
  {
    label: 'Testimonial',
    path: '/testimonial',
    id: 'testimonial',
    icon: HiOutlineClipboardList,
  },
  { label: 'Contact', path: '/contact', id: 'contact', icon: HiOutlineMail },
]
